module.exports = __webpack_public_path__ + "static/1337522625.37d6be7e.jpg";